import { PersonDetailsType, PersonType } from '@app-types/person';

export function isPro(user?: PersonDetailsType): boolean {
    if (!user) {
        return false;
    }
    return user.type === PersonType.PRO;
}
